import React from "react"

const Blog = () => {
  return <div className="blog" />
}

export default Blog
